import LanguagePageContainer from '@/components/language-page/LanguagePageContainer'

const FindTutorLanguage = () => <LanguagePageContainer variant="learn" />

export default FindTutorLanguage
